module.exports = __webpack_public_path__ + "static/51-edb43dd95ea534359b90e1ae33060d59.png";